import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {Col, Progress, Row} from 'reactstrap';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PopUp from '../../Shared/Popup/PopUp';
import cycleRemainingDaysIcon from '../CellularSurfingUseDetailsBlock/images/cycleRemainingDays.svg';
import personIcon from '../CellularSurfingUseDetailsBlock/images/person.svg';
import alertIcon from './images/alert.svg'; 
import {gtag4} from '../../../utilities/analytics/tracking';

const BusinessDataUsagePopUp = (props) => {
  const [isFinishedGetSurfingDataUsageDetails, setIsFinishedGetSurfingDataUsageDetails] = useState(false);
  const [linkPopUpTitle, setLinkPopUpTitle] = useState('');
  const [linkPopUpText, setLinkPopUpText] = useState('');

  const openSocPopUp = (item) => {
    gtag4({
      event: 'BrowsingInfo_PackageExpansionPage',
      action: 'PackageExpansionPage'
    });
    props.setSelectedOffer(item);
    props.setSelectedSubscriber(item);
    props.setIsShowSocPopUp(true);
  };
  const setPurchaseBox = (item) => {
    var title = '';
    var content = '';
    const showSocOfferForItem = props.showSocOffers && item.dataUsage.percentageUsed >= props.dataOfferThresholdPercentage;
    if (showSocOfferForItem) {
      if (props.showSocOffers) {
        content = 'חבילת הגלישה עשויה להסתיים לפני סוף מחזור החיוב.\n רוצים להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט?';
      } else if (item.isPurchase2) {
        content = 'חבילת הגלישה הסתיימה, השימושים כעת במסגרת חריגה.\n רוצים להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט?';
      } else if (item.isPurchase3 || item.isPurchase4) {
        title = 'ניצלת את כל חבילת הגלישה';
        content = 'הגלישה נחסמה. רוצים להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט כבר מעכשיו?';
      }
    } else {
      if (item.isCantPurchase1 || item.isCantPurchase2) {
        title = 'ניצלתם את כל חבילת הגלישה';
        content = 'הגלישה נחסמה. באפשרותכם להמשיך לגלוש לאחר חידוש החבילה {0}'.replace(
          '{0}',
          item.isNextCycleDate ? 'בתאריך ' + item.nextCycleDate : ''
        );
      }
    }

    if (content != '') {
      return (
        <Row>
          <Col xs='12' sm='12' md='9'>
            <div className='purchase-wrapper'>
              <Row>
                <Col xs='12' sm='12' md='12'>
                  {title != '' && (
                    <div className='purchase-title'>
                      <Image src={alertIcon} className='alert-icon' />
                      {title}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs='12' sm='12' md='12'>
                  <div className='purchase-text'>
                    {title == '' && (
                      <span className='icon-wrapper'>
                        <Image src={alertIcon} className='alert-icon' />
                      </span>
                    )}
                    <p>
                      {content.split(/\r\n|\n|\r/gm).map((line) => {
                        return (
                          <p>
                            {line}
                            <br />
                          </p>
                        );
                      })}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className='purchase-options'>
                <span className='purchase-description'>בחרו את החבילה שמתאימה עבורכם:</span>
                {props.availableSocs.map((availableSoc, index) => {
                  return (
                    <a href='javascript:void(0);' onClick={() => openSocPopUp(availableSoc)}>
                      {availableSoc.soc.value}
                    </a>
                  );
                })}
              </Row>
            </div>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Col xs='12' sm='6' md='12' lg='8'>
        {props.dataUsage.surfingUseDetailsItemList.map((item, i) => (
          <div key={i} className='surfingUseDataItem'>
            <div className='subscriber'>
              <span className='icon'>
                <Image src={personIcon} />
              </span>
              <div className='phoneNumber'>{item.cli}</div>
            </div>
            {item.errorDesc ? (
              <Row>
                <Col xs='8' sm='6' md='8' lg='8'>
                  <div className='error-wrapper'>
                    {item.errorDesc == 'EmptyDataUsage' && <p>במנוי זה לא נמצאו שימושי גלישת סלולר להצגה</p>}
                  </div>
                </Col>
              </Row>
            ) : (
              <>
                <Row className='justify-content-md-between'>
                  {item.isUnlimited ? (
                    <Col xs='12' sm='6' md='8' lg='8'>
                      <div className='unlimited-wrapper'>
                        <div className='unlimited-text'>גלשת &nbsp;</div>
                        <div className='unlimited-text unlimited-data-used'>
                          &nbsp; {item.dataUsage.used} {item.dataUsage.usedUnitOfMeasure}
                        </div>
                        <div className='unlimited-text PT5'>מתוך חבילת הגלישה שלך </div>
                      </div>
                    </Col>
                  ) : (
                    <Col xs='12' sm='6' md='8' lg='8'>
                      <div className='limited-wrapper'>
                        <div className='status-bar-wrapper'>
                          <div className='text-wrapper clearfix'>
                            <div className='text'> גלישה במסגרת החבילה </div>
                            <div className='capacity'>
                              <span className='used'>
                                {item.dataUsage.used}
                                {!item.isSameUnitDataUsage ? item.dataUsage.usedUnitOfMeasure : null}
                              </span>
                              /{item.dataUsage.quantity}&nbsp;{item.dataUsage.quantityUnitOfMeasure}
                            </div>
                          </div>
                          <div className='status-bar-bg'>
                            <Progress value={item.dataUsage.statusBarWidth} />
                          </div>
                        </div>

                        {item.isDisplayDeviation && (
                          <div className='status-bar-wrapper deviation data-overhead'>
                            <div className='text-wrapper clearfix'>
                              <div className='text'> גלישה מעבר לחבילה </div>
                              <div className='capacity'>
                                <span className='used'>
                                  {item.dataOverhead.used}
                                  {!item.isSameUnitDataOverhead ? item.dataOverhead.usedUnitOfMeasure : null}
                                </span>
                                /{item.dataOverhead.quantity}
                                {item.dataOverhead.quantityUnitOfMeasure}
                              </div>
                            </div>
                            <div className='status-bar-bg'>
                              <Progress value={item.dataOverhead.statusBarWidth} />
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  )}
                  <div className='cycleRemainingDays'>
                    <Image src={cycleRemainingDaysIcon} />
                    <div className='textCalender'>
                      <div className='days-numbers'>{item.cycleRemainingDays}</div>
                      <div>ימים</div>
                    </div>
                    <div className='text'>
                      נותרו עד סוף <br /> מחזור החיוב
                    </div>
                  </div>
                </Row>
                {setPurchaseBox(item)}
              </>
            )}
          </div>
        ))}
      </Col>
      <PopUp
        className='surfing-use-popup'
        showPopUp={props.showPopUpLink}
        onClose={() => {
          closePopUpLink();
        }}>
        <h2>{linkPopUpTitle}</h2>
        <p>{linkPopUpText}</p>
      </PopUp>

      <PopUp
        className='surfing-use-popup'
        showPopUp={props.showPopUpAddPackageResult}
        onClose={() => {
          closePopUpAddPackageResult();
        }}>
        {props.isSuccessAddPackage ? (
          <div className='success-image-wrapper'>
            <Lottie options={{animationData: CheckedAnimation, loop: false}} width={127} height={127} />
          </div>
        ) : null}
        {props.isSuccessAddPackage ? (
          <h2 className='success'>הרחבת הגלישה הותקנה בהצלחה</h2>
        ) : (
          <h2 className='failed'>מצטערים, ההתקנה לא הצליחה</h2>
        )}
        {props.isSuccessAddPackage ? (
          <>
            <p className='success'>המשך גלישה נעימה!</p>
            <BtnSubmit onclick={() => closePopUpAddPackageResult()} text='סגירה' formid='cellularDataUsage'></BtnSubmit>
          </>
        ) : (
          <>
            <p className='failed'>
              {' '}
              במידה וכבר רכשת הרחבה לחבילת הגלישה, אין באפשרותך לבצע זאת שוב.
              <br />
              לפרטים נוספים ניתן לפנות למוקד השירות&nbsp;
              {isMobile ? null : window.Config.technicalSupportPhone + ' '}
              בשעות הפעילות.
            </p>
            {isMobile ? (
              <a className='call-btn' href={'tel:*'+ window.Config.technicalSupportPhone}>
                <span>חייגו {window.Config.technicalSupportPhone}</span>
              </a>
            ) : (
              <BtnSubmit onclick={() => closePopUpAddPackageResult()} text='סגירה' formid='cellularDataUsage'></BtnSubmit>
            )}
          </>
        )}
      </PopUp>
    </>
  );
};

export default BusinessDataUsagePopUp;
